import { render, staticRenderFns } from "./TreeNode.vue?vue&type=template&id=3bbff6b2"
import script from "./TreeNode.vue?vue&type=script&lang=js"
export * from "./TreeNode.vue?vue&type=script&lang=js"
import style0 from "./TreeNode.vue?vue&type=style&index=0&id=3bbff6b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports